import React from "react";
import Files from 'react-files';
import $ from "jquery";
import './Style.css';
import Image_of_uploader from '../../../assets/img/img_upload/upload.svg'
import * as actionCreators from '../../../store/Action'
import {connect} from "react-redux";
import {Button, Icon} from "semantic-ui-react";
import * as common from "../../../const/Common/CommonFunc";


function convertToBase64(file) {
  //Read File
  var selectedFile = file;
  //Check File is not Empty
  if (selectedFile.length > 0) {
    // Select the very first file from list
    var fileToLoad = selectedFile[0];
    // FileReader function for read the file.
    var fileReader = new FileReader();
    var base64;
    // Onload of file read the file content
    fileReader.onload = function(fileLoadedEvent) {
      base64 = fileLoadedEvent.target.result;
      // Print data in console
      // console.log(base64);
    };
    // Convert data to base64
    fileReader.readAsDataURL(fileToLoad);

    return base64;
  }
}

class FileUpload extends React.Component {

  state = {
    file: this.props.files,
    image: null,
    isGetImage: false
  };

//-------------------------------------------[ function: On File Change  ]----------------------------------------------

  handleFileChange = (file) => {
    const urlArray = [];

    let reader = new FileReader();
    // let file = e.target.files[0];
    //
    // if (file !== undefined) {
    //   reader.onloadend = () => {
    //     this.setState({
    //       file: file
    //       // imagePreviewUrl: reader.result
    //     });
    //   };

    // reader.readAsDataURL(file);
    // urlArray.push(reader);
    // this.props.fileUploaderHandler(file);
    // let bfile = convertToBase64(file);
    // console.log("FileX : ",file);
    // console.log("FileB : ",bfile);

    // let formData = new FormData();    //formdata object
    // formData.append("file",file);
   // this.props.sendFiles(formData, file[0].name);

    if(file[0] !== undefined) {
      if(file[0].size <= 52428800) {
        // let base64 = "";
        // getBase64(file).then(res => {
        //   base64 = res;
          // let formData = new FormData();
          // formData.append("file", file);
          this.props.sendFiles(file[0], file[0].name);
        // });
      } else {
        common.notifyMessage("Maximum size of an attachment is 50MB.");
      }
    } else {
      common.notifyMessage("Invalid file type. Please, upload .pdf file.");
    }


  }

//------------------------------------------------[ render & return  ]--------------------------------------------------

  render() {

    let file = [];
    let view = <img key={"x1"} src={Image_of_uploader} width='70px'/>;

    view = <div style={{marginTop:"12%"}}><span style={{background: '#eceff1', color:'white', padding: '50px'}}>pdf</span></div>

    if(this.props.preview.length!==0) {

      file.push(this.props.preview[0]);
      // view = <img key={file[0].preview.id} src={file[0].preview.url} width='100px'/>
      view = <div style={{width: '100%', height:'100%', background: 'gray', color:'white'}}>PDF</div>

    }

    view = <div style={{width:"100%", textAlign: "center",color:"#e0e0e0"}}>
               <img style={{display:"block",position: "relative",
                 margin: "auto",
                 top: "40px",
                 bottom: "0"}} key={"x1"} src={Image_of_uploader} width='40px'/>
                <span style={{display:"block",marginTop: "50px"}}>Upload pdf</span>
    </div>;




    view = <div style={{width:"100%", textAlign: "center",color:"#e0e0e0", position:"relative"}}>
      <i className="circular huge icons" style={{display:"block",position: "relative",
        margin: "auto",
        top: "40px",
        bottom: "0"}}>
        <i className="file pdf icon"></i>
      </i>

      <div className="pdfuploadhover">
        <div>
          <i className="trash alternate icon"></i>
        </div>
        <span>[pdf name]</span>

      </div>

    </div>;




    let style = "files2";

    if(this.props.fileStyle !== "file2") {
      style = "files1";
    }


//-------------[ return  ]--------------

    return(
      <div>
        {/*//-------------[ file uploader ]--------------*/}


            <Files
              className="miniUploader"
              // onChange={this.props.onFilesChange}
              onChange={this.handleFileChange}
              onError={this.props.onFilesError}
              accepts={['.pdf', '.jpg', '.png', '.jpeg']}
              multiple ={false}
              maxFileSize={10000000}
              minFileSize={0}
              clickable
            >

              <Button color={"rgba(255, 255, 255, 0.42)"} className={"btcolor1"}><Icon name='upload' />{this.props.btnName}</Button>

            </Files>


      </div>

    );
  }

}

var cw = $('.files').width();
$('.files').css({'height':cw+'px'});

// const mapDispatchToProps = (dispatch) => {
//   return {
//     fileUploaderHandlerx: (file) => dispatch(actionCreators.fileUploaderHandler(file)),
//     imageUploaderHandler: (image) => dispatch(actionCreators.imageUploaderHandler(image))
//   }
// };
//
// export default connect(null, mapDispatchToProps)(FileUpload);

export default FileUpload;
